import { FC } from 'react'

import { BaseNavbarProps } from '@/components/navbar/Navbar'
import { As } from '@/components/as'
import { composeClasses } from '@/utils/compose-classes'

export interface SubscriptionContentProps {
  subscription: BaseNavbarProps['subscription']
  className?: string
}
export const SubscriptionContent: FC<SubscriptionContentProps> = ({
  subscription,
  className
}) => {
  if (subscription?.plan === 'premium') {
    return (
      <As
        as={subscription?.onClick ? 'button' : 'div'}
        onClick={subscription?.onClick}
        className={composeClasses(
          className,
          subscription?.onClick &&
            'hover:underline hover:brightness-90 active:brightness-75',
          'p-1 px-2 text-notif-purple text-body-bold-m bg-notif-purple-01 rounded-full'
        )}
      >
        Quedan {subscription?.daysLeft} días de Wiggot Pro
      </As>
    )
  }

  if (subscription?.plan === 'basic') {
    return (
      <button
        type="button"
        onClick={subscription.onClick}
        className={composeClasses(
          className,
          'p-1 px-2 text-notif-blue text-body-bold-m bg-notif-blue-01 rounded-full underline hover:brightness-90 active:brightness-75'
        )}
      >
        Contratar un plan
      </button>
    )
  }

  return <></>
}
